import { Component, OnInit } from '@angular/core';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FormGroup, FormBuilder, Validators, FormControl } from '@angular/forms';
import * as FileSaver from 'file-saver-es';
import { DatePipe, formatDate } from '@angular/common';
import { ReportsHistoryService } from 'src/app/services/reports-history.service';
import { ReportsCommonService } from 'src/app/services/reports-common.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CommonConstant } from 'src/app/core/constant/common.constant';
import { Constants } from 'src/app/constants';
import { AetStateService } from 'src/app/services/aet-state.service';
import { Router } from '@angular/router';
import moment from 'moment';
import { ReplaySubject, map, startWith } from 'rxjs';

@Component({
  selector: 'app-reports-history',
  templateUrl: './reports-history.component.html',
  styleUrls: ['./reports-history.component.scss'],
  standalone: false // NOSONAR
})

export class ReportsHistoryComponent implements OnInit {
  faChevronRight = faChevronRight;
  event: any;
  dropdownOptionHistoryPlant: any;
  dropdownOptionHistoryRegion: any;
  dropdownOptionHEvent: any;
  dropdownOptionHResolution: any;
  selectedHistoryPlant: any;
  selectedHistoryResolution: any[] = [];
  selectedHistoryRegion: any[] = [];
  selectedHistoryEvent: any[] = [];
  errorMessage: any;
  successMessage: any;
  isAccessible = true;
  nextDate: any;
  newDate: any;
  now = new Date();
  maxDate = moment(new Date()).format('YYYY-MM-DD');
  pastDate = new Date(this.now.getTime() - 86400000);
  test = new Date(this.pastDate.getFullYear() - 5, this.pastDate.getMonth(), this.pastDate.getDate());
  minDate = this.test.toISOString().split('T')[0];
  yesterday = this.pastDate.toISOString().split('T')[0];
  regionFilterCtrl: FormControl = new FormControl();
  filteredRegion: ReplaySubject<any[]> = new ReplaySubject(1);
  eventFilterCtrl: FormControl = new FormControl();
  filteredEvent: ReplaySubject<any[]> = new ReplaySubject(1);
  resFilterCtrl: FormControl = new FormControl();
  filteredRes: ReplaySubject<any[]> = new ReplaySubject(1);
  constructor(private readonly reportshistoryService: ReportsHistoryService,
    public formBuilder: FormBuilder,
    private readonly commonService: ReportsCommonService,
    public datepipe: DatePipe,
    private readonly ngxUiLoaderService: NgxUiLoaderService,
    public constants: Constants,
    private readonly aetStateService: AetStateService,
    private readonly router: Router
  ) {
    const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    const userAttributes = fgaDetails?.user?.applicationUserAttribute?.[0]?.userAttributes ?? [];
    const getAttr = (key: string) => userAttributes.find((a: any) => a.key === key)?.value ?? null;
    const userInfo = {
      userPrincipalName: fgaDetails?.user?.userPrincipalName,
      externalUserId: fgaDetails?.user?.externalUserId,
      additionalSupplierCodes: getAttr('additionalSupplierCodes'),
      additionalLpCode: getAttr('additionalLpCode'),
      additionalNAMC: getAttr('additionalNAMC'),
      additionalDomicile: getAttr('additionalDomicile'),
      firstName: fgaDetails?.user?.firstName,
      lastName: fgaDetails?.user?.lastName,
      email: fgaDetails?.user?.email,
      roles: (fgaDetails?.roles ?? []).map((r: any) => r.displayName),
    };
    this.ngxUiLoaderService?.start(CommonConstant.loader);
this.commonService.getCommonReportByUser(userInfo).subscribe(data => { // NOSONAR
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      if (data) {
        this.event = data
        if (this.event.body.reportPlants && this.event.body.reportPlants.length > 0) {
          this.event.body.reportPlants.sort((a, b) => {
            const codeA = a.itemCode?.toLowerCase() ?? '';
            const codeB = b.itemCode?.toLowerCase() ?? '';

            if (codeA < codeB) { return -1; }
            if (codeA > codeB) { return 1; }
            return 0;
          });

          this.dropdownOptionHistoryPlant = [];
          //this.dropdownOptionHistoryPlant.push({ label: 0, value: 'ALL' })
          this.event.body.reportPlants.forEach((obj, _index) => {
            const option = this.createOption(obj?.itemCode, obj?.itemCode);
            if (option) {
              this.dropdownOptionHistoryPlant.push(option);
            }
          });
          this.selectedHistoryPlant = "01TMK"
        }
        if (this.event.body.hreportRegions && this.event.body.hreportRegions.length > 0) {
          this.dropdownOptionHistoryRegion = [];
          //this.dropdownOptionHistoryRegion.push({ label: 0, value: 'ALL' })
          this.event.body.hreportRegions.forEach((obj, _index) => {
            const option = this.createOption(obj?.regionCode, obj?.regionDesc);
            if (option) {
              this.dropdownOptionHistoryRegion.push(option);
            }
          });
          this.filteredRegion.next(this.dropdownOptionHistoryRegion?.slice());

          this.selectedHistoryRegion = this.dropdownOptionHistoryRegion;
          this.form?.get('region')?.setValue([...this.dropdownOptionHistoryRegion]);
        }
        if (this.event.body.eventTypeList && this.event.body.eventTypeList.length > 0) {
          this.dropdownOptionHEvent = [];
          //this.dropdownOptionHEvent.push({ label: 0, value: 'ALL' })
          this.event.body.eventTypeList.forEach((obj, _index) => {
            const option = this.createOption(obj?.eventTypeId, obj?.description);
            if (option) {
              this.dropdownOptionHEvent.push(option);
            }
          });
          this.filteredEvent.next(this.dropdownOptionHEvent?.slice());

          this.selectedHistoryEvent = this.dropdownOptionHEvent;
          this.form?.get('event_Type')?.setValue([...this.dropdownOptionHEvent]);
        }
        if (this.event.body.resolutionTypes && this.event.body.resolutionTypes.length > 0) {
          this.dropdownOptionHResolution = [];
          //this.dropdownOptionHResolution.push({ label: 0, value: 'ALL' })
          this.event.body.resolutionTypes.forEach((obj, _index) => {
            const option = this.createOption(obj?.resolutionId, obj?.description);
            if (option) {
              this.dropdownOptionHResolution.push(option);
            }
          });
          this.filteredRes.next(this.dropdownOptionHResolution?.slice());

          this.selectedHistoryResolution = this.dropdownOptionHResolution;
          this.form?.get('reso_Type')?.setValue([...this.dropdownOptionHResolution]);
        }


      }
    }, err => {
      this.ngxUiLoaderService.stop(CommonConstant.loader);
      this.errorMessage = "ERROR: Filters generating too many records to display. please reduce search criteria.";
      console.info(err)
    })
  }

  form!: FormGroup;
  submitted: boolean = false;
  curDate = formatDate(new Date(), 'yyyy/MM/dd', 'en');

  ngOnInit() {
    this.form = this.formBuilder.group({
      start_Date: ['', [Validators.required]],
      end_Date: ['', [Validators.required]],
      plant: ['01TMK'],
      region: [[]],        // ✅ must be array
      event_Type: [[]],    // ✅ must be array
      reso_Type: [[]],     // ✅ must be array
    });
    this.regionFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownOptionHistoryRegion) : this.dropdownOptionHistoryRegion?.slice())
      )
      .subscribe(filtered => {
        this.filteredRegion.next(filtered);
      });
    this.eventFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownOptionHEvent) : this.dropdownOptionHEvent?.slice())
      )
      .subscribe(filtered => {
        this.filteredEvent.next(filtered);
      });
    this.eventFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownOptionHEvent) : this.dropdownOptionHEvent?.slice())
      )
      .subscribe(filtered => {
        this.filteredEvent.next(filtered);
      });
    this.resFilterCtrl.valueChanges
      .pipe(

        startWith(''),
        map(search => search ? this.filterOption(search, this.dropdownOptionHResolution) : this.dropdownOptionHResolution?.slice())
      )
      .subscribe(filtered => {
        this.filteredRes.next(filtered);
      });
  }
  private asNonEmptyString(value: unknown): string | null {
    if (value === null || value === undefined) {
      return null;
    }

    const normalized = String(value).trim();
    return normalized.length > 0 ? normalized : null;
  }

  private createOption(label: unknown, value: unknown): { label: string; value: string } | null {
    const normalizedLabel = this.asNonEmptyString(label);
    const normalizedValue = this.asNonEmptyString(value);

    if (!normalizedLabel || !normalizedValue) {
      return null;
    }

    return {
      label: normalizedLabel,
      value: normalizedValue,
    };
  }

  private filterOption(search: string, list: any): any[] {
    const filterValue = search.toLowerCase();
    return (list || []).filter(d =>
      d?.label?.toLowerCase()?.includes(filterValue) ||
      d?.value?.toLowerCase()?.includes(filterValue)
    );
  }
  isAllSelected(selected: any[], list: any[]): boolean {
    return (selected || []).length === (list || []).length;
  }

  isIndeterminate(selected: any[], list: any[]): boolean {
    const len = (selected || []).length;
    return len > 0 && len < (list || []).length;
  }


  toggleSelectAll(type: 'region' | 'event' | 'resolution', event: any) {

    const checked = event.checked;

    if (type === 'region') {
      this.form.get('region')?.setValue(
        checked ? this.dropdownOptionHistoryRegion.map(x => x) : []
      );
    }

    if (type === 'event') {
      this.form.get('event_Type')?.setValue(
        checked ? this.dropdownOptionHEvent.map(x => x) : []
      );
    }

    if (type === 'resolution') {
      this.form.get('reso_Type')?.setValue(
        checked ? this.dropdownOptionHResolution.map(x => x) : []
      );
    }
  }


  downloads() {
    const start = formatDate(this.form.value.start_Date, 'dd/MM/yyyy', 'en');
    const end = formatDate(this.form.value.end_Date, 'dd/MM/yyyy', 'en');

    this.successMessage = null;
    this.errorMessage = null;
    const fgaDetails: any = JSON.parse(sessionStorage.getItem('FGA'));
    const userAttributes = fgaDetails?.user?.applicationUserAttribute?.[0]?.userAttributes ?? [];
    const getAttr = (key: string) => userAttributes.find((a: any) => a.key === key)?.value ?? null;
    const userInfo = {
      userPrincipalName: fgaDetails?.user?.userPrincipalName,
      externalUserId: fgaDetails?.user?.externalUserId,
      additionalSupplierCodes: getAttr('additionalSupplierCodes'),
      additionalLpCode: getAttr('additionalLpCode'),
      additionalNAMC: getAttr('additionalNAMC'),
      additionalDomicile: getAttr('additionalDomicile'),
      firstName: fgaDetails?.user?.firstName,
      lastName: fgaDetails?.user?.lastName,
      email: fgaDetails?.user?.email,
      roles: (fgaDetails?.roles ?? []).map((r: any) => r.displayName),
    };
    const params = {
      endDate: end,
      startDate: start,

      eventType: this.form.value.event_Type || [],
      region: this.form.value.region || [],
      resoType: this.form.value.reso_Type || [],

      plant: this.form.value.plant ? [this.form.value.plant] : []
    };

    console.info(params);
    this.ngxUiLoaderService.start(CommonConstant.loader);
    this.reportshistoryService.getHistoryReport(userInfo, params).subscribe({
      next: (response) => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        const filename = "AET-History-" + this.curDate
        const data: Blob = new Blob([(<any>response).body], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        FileSaver.saveAs(data, filename);
      },
      error: () => {
        this.ngxUiLoaderService.stop(CommonConstant.loader);
        this.errorMessage = "ERROR: Filters generating too many records to display. please reduce search criteria.";

      }
    })
  }

  submitForm() {
    console.info(this.form.value);

  }
  onDateChangedStart(event) {
    const { valueStart } = event.target;
    const currentDate = new Date(valueStart);
    this.pastDate = new Date(currentDate.getTime() - 86400000);
    this.test = new Date(this.pastDate.getFullYear() - 5, this.pastDate.getMonth(), this.pastDate.getDate());
    this.minDate = this.test.toISOString().split('T')[0];
    this.yesterday = this.pastDate.toISOString().split('T')[0];
  }
  onDateChangedEnd(event) {
    const { valueEnd } = event.target;
    const currentDate = new Date(valueEnd);
    this.nextDate = new Date(currentDate.getTime() + 86400000);
    this.newDate = this.nextDate.toISOString().split('T')[0];
  }
}
